module.exports = __webpack_public_path__ + "media/images/save-icon-1d597ab4b35aceedaf22c0d5b9ec8d42.svg";